/**
 * 全局常量
 */

/** API 版本 */
export const API_VERSION = 'v1';

/** API 基础路径 */
export const API_BASE_PATH = `/api/${API_VERSION}`;

/** Token 过期时间（秒） */
export const ACCESS_TOKEN_EXPIRES_IN = 3600; // 1 小时
export const REFRESH_TOKEN_EXPIRES_IN = 2592000; // 30 天

/** 密码策略 */
export const PASSWORD_POLICY = {
  minLength: 8,
  requireUppercase: true,
  requireLowercase: true,
  requireNumber: true,
  requireSpecial: false,
} as const;

/** 邮箱验证正则 */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** 默认 KDF 配置 */
export const DEFAULT_KDF_CONFIG = {
  type: 'argon2id' as const,
  iterations: 3,
  memory: 64 * 1024, // 64MB
  parallelism: 4,
};

/** 加密算法 */
export const ENCRYPTION_ALGORITHM = 'AES-GCM';
export const ENCRYPTION_KEY_LENGTH = 256;
export const IV_LENGTH = 12; // 96 bits
export const TAG_LENGTH = 16; // 128 bits

/** 分页默认值 */
export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 50;
export const MAX_PAGE_SIZE = 200;
